export default __webpack_public_path__ + "static/maestro-72577b588daf53a20943221d89bcb209.svg";